import React, { useState } from 'react'
import MotivationTab from './tabs/MotivationTab'
import ComponentTab from './tabs/ComponentTab'
import ProcessTab from './tabs/ProcessTab'
import ResultTab from './tabs/ResultTab'
import { ComponentData } from '../data/ComponentContext'
import { ResultData } from '../data/ResultContext'


function TabView() {

  const { componentIsValid, processIsValid, calculateHeatEvent, motivationIsValid } = ComponentData()
  const { resultIsValid } = ResultData()

  const Tabs = {
    MOTIVATION: 'MOTIVATION',
    BAUTEIL: 'BAUTEIL',
    PROZESS: 'PROZESS',
    ERGEBNIS: 'ERGEBNIS'
  }

  const validTabs = {
    'MOTIVATION': motivationIsValid,
    'BAUTEIL': componentIsValid,
    'PROZESS': processIsValid,
    'ERGEBNIS': resultIsValid,
  }

  const enabledTabs = {
    'MOTIVATION': true,
    'BAUTEIL': motivationIsValid,
    'PROZESS': componentIsValid && motivationIsValid,
    'ERGEBNIS': processIsValid && componentIsValid && motivationIsValid,
  }

  const [activeTab, setActiveTab] = useState(Tabs.MOTIVATION)

  return (
    <div className="tab-view">
      <div className="tab-buttons">
        {Object.values(Tabs).map((tab) => {
          return (<button
            key={"tab-button-" + tab}
            id={"tab-button-" + tab}
            className={tab === activeTab || validTabs[tab] ? "tab-button active" : "tab-button"}
            disabled={!enabledTabs[tab]}
            onClick={() => { setActiveTab(tab) }}>
            <p>{tab}</p>
          </button>)
        })}
      </div>
      <div className="tab-content">
        {activeTab === Tabs.MOTIVATION &&
          <MotivationTab toNextTab={() => { setActiveTab(Tabs.BAUTEIL) }} />
        }
        {activeTab === Tabs.BAUTEIL &&
          <ComponentTab toNextTab={() => { setActiveTab(Tabs.PROZESS) }} toLastTab={() => setActiveTab(Tabs.MOTIVATION)} />
        }
        {activeTab === Tabs.PROZESS &&
          <ProcessTab toNextTab={() => { setActiveTab(Tabs.ERGEBNIS) }} toLastTab={() => setActiveTab(Tabs.BAUTEIL)} />
        }
        {activeTab === Tabs.ERGEBNIS && <ResultTab toLastTab={() => setActiveTab(Tabs.PROZESS)} />}
      </div>
    </div >
  )
}

export default TabView